import { PureLightTheme } from "../../../../styles/theme"
import { COLORS } from "../../../../styles/variables"

export const CardItem = {
  maxWidth: '736px',
  width: '100%',
  cursor: 'pointer',
}

export const TypCity = {
  fontWeight: 300,
  color: COLORS.SMOKEY_GREY,
}

export const TypDescription = {
  display: '-webkit-box',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 3,
  [PureLightTheme.breakpoints.down("md")]: {
    WebkitLineClamp: 2,
  },
}
